let params = {};
export const setQueryParams = (_params) => (params = _params);
export const getQueryParams = () => params;
